import React from 'react';
import { Form, Button, TreeSelect, Popover, Row, Badge } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { AppStore } from 'stores';

const WrapperButtons = styled(Row)`
  align-items: center;
  display: flex;
  justify-content: flex-end;

  button:first-child {
    margin-right: 16px;
  }
`;

const WOFormFilterParts = ({
  optionStatus,
  optionAssigned,
  changeFilter,
  popoverVisible,
  togglePopoverVisibility,
  onClear,
  countFiltersSelected,
}) => {
  const [form] = Form.useForm();

  const handleSubmit = async () => {
    try {
      await form.validateFields();
      togglePopoverVisibility(false);
    } catch (error) {
      AppStore.addError('Validation failed:', error.message);
    }
  };

  const clearData = () => {
    onClear();
    form.resetFields();
    togglePopoverVisibility(false);
  };

  const onChangeField = (key, value) => {
    changeFilter(key, value);
  };

  const filterContent = (
    <Form
      form={form}
      style={{ width: '78vw' }}
      layout="vertical"
      onFinish={handleSubmit}
    >
      <Form.Item label="Filter by Status" name="status">
        <TreeSelect
          treeData={optionStatus}
          onChange={(value) => onChangeField('status', value)}
          allowClear
          treeCheckable
          showCheckedStrategy={TreeSelect.SHOW_PARENT}
          placeholder="Please select Status"
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item label="Filter by Assigned To" name="assignedTo">
        <TreeSelect
          treeData={optionAssigned}
          onChange={(value) => onChangeField('assignedTo', value)}
          allowClear
          treeCheckable
          showCheckedStrategy={TreeSelect.SHOW_PARENT}
          placeholder="Please select Assigned"
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item>
        <WrapperButtons>
          <Button type="default" onClick={clearData}>
            Clear
          </Button>
          <Button type="primary" onClick={() => togglePopoverVisibility(false)}>
            Ok
          </Button>
        </WrapperButtons>
      </Form.Item>
    </Form>
  );

  return (
    <Popover
      placement="bottomLeft"
      open={popoverVisible}
      onOpenChange={togglePopoverVisibility}
      content={filterContent}
      title="Filters"
      trigger="click"
    >
      <Button type="primary" icon={<FilterOutlined />} block>
        Filters{' '}
        {countFiltersSelected > 0 && (
          <Badge
            count={countFiltersSelected >= 10 ? '9+' : countFiltersSelected}
            style={{
              marginLeft: 5,
              backgroundColor: '#fff',
              color: '#123FBF',
            }}
          />
        )}
      </Button>
    </Popover>
  );
};

WOFormFilterParts.propTypes = {
  optionStatus: PropTypes.array.isRequired,
  optionAssigned: PropTypes.array.isRequired,
  changeFilter: PropTypes.func.isRequired,
  popoverVisible: PropTypes.bool.isRequired,
  togglePopoverVisibility: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  countFiltersSelected: PropTypes.number.isRequired,
};

export default WOFormFilterParts;
